import { useParams } from 'react-router-dom';

const useTo = () => {
	const { clientPartitionId, enterpriseId, taskZoneId } = useParams();
	const baseUrl = '/enterprises/' + enterpriseId + '/establishments/' + clientPartitionId + '/zones/' + taskZoneId;

	return (path: string) => baseUrl + path;
};

export default useTo;